import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'cinch-card-accordion',
  templateUrl: './cinch-card-accordion.component.html',
  styleUrl: '../base-cinch-card.component.scss'
})
export class CinchCardAccordionComponent implements AfterViewInit {
  @Input() initialStateOpen!: number;
  @Input() title: string = "<Add Title>"

  display = false;

  ngAfterViewInit(): void {
    // Needs to delay view until after the Input is initialized with a value internally.
    setTimeout(() => {
      this.display = true;
    }, 0);
  }
}
